export default __webpack_public_path__ + "static/media/December2008.d0e25c56.png";